import {
  PLAN_TYPES,
  type PlanType,
} from '../../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'
import {
  BrandContentError,
  findByIdWithSchema,
  GenericContentSchema,
  GenericGroupSchema,
  parseEntries,
  type GenericContent,
  type GenericGroup,
  type GenericSection,
} from '../../../../../brand/lib/types/contentful'

type PlanItem = {
  id: string
  label: string
  value: PlanType
}

export type HeroSectionContent = {
  hero?: GenericContent
  ideList?: GenericContent
  planItems: PlanItem[]
  planTypes?: GenericContent
  pricingOptions?: GenericGroup
}

const DEFAULT_PLAN_ITEMS: PlanItem[] = [
  {id: 'individual-plan-tab', value: PLAN_TYPES.Individual, label: 'For individuals'},
  {id: 'business-plan-tab', value: PLAN_TYPES.Business, label: 'For businesses'},
]

export function toHeroSectionContent(section: GenericSection): HeroSectionContent {
  const hero = findByIdWithSchema(section.fields.content, 'featuresCopilotPlansHero', GenericContentSchema)
  const ideList = findByIdWithSchema(section.fields.content, 'featuresCopilotPlansHeroIdeList', GenericContentSchema)
  const planTypes = findByIdWithSchema(section.fields.content, 'featuresCopilotPlanTypes', GenericContentSchema)
  const pricingOptions = findByIdWithSchema(section.fields.content, 'featuresCopilotPricingOptions', GenericGroupSchema)
  const planTypeEntries = planTypes?.fields.content
    ? parseEntries(planTypes.fields.content, GenericContentSchema)
    : undefined
  const planItems =
    planTypeEntries?.map(item => {
      const {id, heading} = item.fields

      if (!id || !isPlanType(id) || !heading) {
        throw new BrandContentError(`Plan type "${id ?? item.sys.id}" must include a valid plan type id and heading`)
      }

      return {id: `${id}-plan-tab`, value: id, label: heading}
    }) ?? DEFAULT_PLAN_ITEMS

  return {hero, ideList, planItems, planTypes, pricingOptions}
}

function isPlanType(value: string): value is PlanType {
  return value === PLAN_TYPES.Individual || value === PLAN_TYPES.Business
}
